module.exports = __webpack_public_path__ + "static/img/mb_download_banner.ec1cc71.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/download/mb_download_banner.png
// module id = r5s8
// module chunks = 1